import {get, post} from './request';
import {always, applySpec, applyTo, compose, constructN, defaultTo, identity, pick, prop,} from 'ramda';

const getURLSearchParams = constructN(1, URLSearchParams);
const html = prop('html');

/** @typedef { import('axios').AxiosRequestConfig } AxiosRequestConfig */

/**
 * Search products by query
 *
 * @param {string} query Search query
 * @param {AxiosRequestConfig?} config Optional axios configuration
 * @returns {Promise<string>}
 */
export const getProductsByQuery = (query, config) =>
    get(
        '/api/Search/getAutocomplete/',
        config,
        applyTo(query, compose(
            getURLSearchParams,
            applySpec({Q: identity})
        ))
    )
        .then(html)
        .catch(defaultTo(''));

/**
 * Add product to basket
 *
 * @param {string|number} id Product id
 * @param {AxiosRequestConfig?} config Optional axios configuration
 * @returns {Promise<object|{}>}
 */
export const addProductToBasket = (id, config) =>
    post(
        '/api/Basket/addToBasket/',
        config,
        applyTo(id, compose(
            getURLSearchParams,
            applySpec({PRODUCT_ID: identity})
        ))
    )
        .then(identity)
        .catch(defaultTo({}));

/**
 * Add product to favourites
 *
 * @param {string|number} id Product id
 * @param {AxiosRequestConfig?} config Optional axios configuration
 * @returns {Promise<boolean>}
 */
export const addProductToFavourites = (id, config) =>
    post(
        '/api/Favorite/addFavorite/',
        config,
        applyTo(id, compose(
            getURLSearchParams,
            applySpec({ID: identity})
        ))
    )
        .then(pick(['status']))
        .catch(applySpec({
            status: always(false),
        }));
